import React from 'react';
import '../../components/css/popupstyle.css';
import editIcon from '../.././components/css/dark/img/theme-images/edit.svg';
import $ from 'jquery';
import Pagination from "react-js-pagination";
import { userService } from '../../_services';

class ManageGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            userdata: JSON.parse(localStorage.getItem('user')),
            activePage: 1,
            UserList: [],
            UserList_Temp: [],
            mainAPIresult: [],
            error: '',
            editable: false,
            groupActivePagin: 1,
            activeState: false,
            Data_Not_Found: ''
        }
    }  
    componentDidMount() {
        this.fetchDataLocally(this.state.userdata.paramsname, this.state.userdata.userrole, this.props.dataId);
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    fetchDataLocally(roleName, roleType, id) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, id })
            };
            return fetch(`/api/admin/GetGroupList`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length <= 12) {
                            $('.manage-email').addClass('less-than');
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: apidata, loader: false });
                        }
                        else {
                            $('.manage-email').removeClass('less-than');
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: usertemplistobj, loader: false });
                        }
                        if (this.props.backActivePagin > 1) {
                            this.handlePageChange(this.props.backActivePagin);
                        }
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    handlePageChange = (pageNumber) => {
        $("li").removeClass('active');
        if (this.props.backActivePagin > 1 && this.state.activeState == false) {
            this.state.mainAPIresult.forEach(function (a, index) {
                a.isineditedmode = false;
            });
            let updated = this.state.mainAPIresult;
            let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
            let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice((pageNumber - 1) * 12, 12) : userlistobj;
            this.setState({ UserList: updated, mainAPIresult: updated, activePage: pageNumber, UserList_Temp: usertemplistobj, loader: false, groupActivePagin: pageNumber, activeState: true, error: ''  });
            $("a[aria-label='Go to page number " + this.props.backActivePagin + "']").parents("li").addClass('active');
        } else {
            this.state.mainAPIresult.forEach(function (a, index) {
                a.isineditedmode = false;
            });
            let updated = this.state.mainAPIresult;
            let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
            let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice((pageNumber - 1) * 12, 12) : userlistobj;
            this.setState({ UserList: updated, mainAPIresult: updated, activePage: pageNumber, UserList_Temp: usertemplistobj, loader: false, groupActivePagin: pageNumber, error: '' });
        }
    }
    SearchOnKeyUp = e => {
        let serachText = $('#SearcInput').val();
        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function(e1) {
            return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function(e1) {
            return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

        let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
        this.setState({ activePage: 0, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, loader: false });
    }
    editGroup = e => {
        this.state.mainAPIresult.forEach(function (a, index) {
            if (a.groupNumber == e.target.getAttribute('datagroup')) {
                a.isineditedmode = true;
            }
        });
        let updated = this.state.mainAPIresult;
        try {
            if (updated.length <= 12)
                this.setState({ UserList: updated, mainAPIresult: updated, UserList_Temp: updated, loader: false, error: '' });
            else {
                let userlistobj = JSON.parse(JSON.stringify(updated));
                let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
                this.setState({ UserList: updated, mainAPIresult: updated, UserList_Temp: usertemplistobj, loader: false, error: '' });
            }
            this.SearchOnKeyUp();
        }
        catch (error) {
        }
    }
    handleCancel = e => {
        this.state.mainAPIresult.every(function (a, index) {
            if (a.groupNumber == e.target.getAttribute('data-text')) {
                a.isineditedmode = false;
                return false;
            }
            else return true;
        });

        let updated = this.state.mainAPIresult;
        try {
            if (updated.length <= 12)
                this.setState({ UserList: updated, mainAPIresult: updated, UserList_Temp: updated, loader: false, error: '' });
            else {
                let userlistobj = JSON.parse(JSON.stringify(updated));
                let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
                this.setState({ UserList: updated, mainAPIresult: updated, UserList_Temp: usertemplistobj, loader: false, error: '' });
            }
            this.SearchOnKeyUp();
        }
        catch (error) {
        }
    }    
    saveUpdates = (e) => {
        let groupNumber = $(e.target).parents('.userDashData').find('.first-one').text();
        let updatedCommission = $(e.target).parents('.userDashData').find('input[name = "commission"]').val().replace('$','');
        let pattern = /^[A-Za-z]+$/;
        if (updatedCommission == '' || updatedCommission == null) {
            this.setState({ error: 'Commission cannot be blank' });
        } else if (pattern.test(updatedCommission)) {
            this.setState({ error: 'Commission must be numeric e.g. 1.5' });
        } else if (updatedCommission.indexOf('$') > -1 || updatedCommission.indexOf(' ') > -1) {
            this.setState({ error: 'Commission must be numeric e.g. 1.5' });
        } else if (updatedCommission < 0 || updatedCommission == 0) {
            this.setState({ error: 'Commission should be greater than 0' });
        } else if (updatedCommission > 10) {
            this.setState({ error: 'Commission should not be more than 10' });
        } else if (!userService.validateCurrency(updatedCommission)) {
            this.setState({ error: 'Commission must be numeric e.g. 1.5' });
        } else {
            this.updateGroupData(this.state.userdata.paramsname, this.state.userdata.userrole,  this.props.dataId, groupNumber, '$' + parseFloat(updatedCommission, 10).toFixed(2).toString(), e.target.getAttribute('data-text'), updatedCommission);
        }
    }
    updateGroupData = (roleName, roleType, WhName, GN, WhComm, e, updatedCommission) => {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ roleName, roleType, WhName, GN, WhComm })
            };
            return fetch(`/api/admin/Update_GN`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    if (apidata.length > 0) {
                        if (apidata[0].code == '1') {
                            this.state.mainAPIresult.forEach(function (a) {
                                if (a.groupNumber == e) {
                                    a.isineditedmode = false;
                                    a.commission = '$' + parseFloat(updatedCommission, 10).toFixed(2).toString();
                                }
                            });
                            let updated = this.state.mainAPIresult;
                            try {
                                if (updated.length <= 12)
                                    this.setState({ UserList: updated, mainAPIresult: updated, UserList_Temp: updated, loader: false, error: apidata[0].statusMessage});
                                else {
                                    let userlistobj = JSON.parse(JSON.stringify(updated));
                                    let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
                                    this.setState({ UserList: updated, mainAPIresult: updated, UserList_Temp: usertemplistobj, loader: false, error: apidata[0].statusMessage});
                                }
                                this.SearchOnKeyUp();
                            }
                            catch (error) {
                            }
                        }
                        else {
                            this.setState({ loader: false, error: apidata[0].statusMessage });
                        }
                    }
                    else {
                        this.setState({ loader: false, error: apidata[0].statusMessage });
                    }
                });
        }
        catch (error) {
        }
    }
    createGroup = (e) => {
        let activePagin = $(e.target).attr('gActivePagin');
        this.props.openGroupPopup(this.props.dataId, this.props.wholesalerName, this.props.activePagin, activePagin, this.props.whIsRule, this.props.whSearch);
        this.props.closeManageGroupPopup(this.props.dataId, this.props.wholesalerName, this.props.activePagin, activePagin, this.props.whIsRule, this.props.whSearch);
    }
    handleBack = () => {
        this.props.closeManageGroupPopup(this.props.dataId, this.props.wholesalerName, this.props.activePagin, this.state.groupActivePagin);
        this.props.openWholesalerPopup(this.props.activePagin, this.props.whSearch);
    }
    render() {
        const { error } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;

        return (
            <div className="manage-scroll manage-distributor-design">
                <div className='popup mfp-zoom-in manage-email manage-profile'>
                    <div className='popup_inner'>

                     <h1>{this.props.titleText}<button onClick={this.handleBack}>X</button></h1>
                    {
                        this.state.loader ? (<div className="theme-loader group-list"></div>) : null
                    }
                    <button className="btn add-wholesaler back"  onClick={disabled ? null : this.handleBack}>Back</button>
                     <button className="btn add-wholesaler" gActivePagin={disabled ? null : this.state.groupActivePagin} onClick={this.createGroup}>Add Group Number</button>
                    <div className="searchSection populate">
                        <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                            <div className="autocomplete">
                                <input disabled={disabled} id="SearcInput" type="text" name="PhCityInput" scroll-id="CITY" data-id="dynamic" placeholder="Search" onKeyUp={this.SearchOnKeyUp} className="form-control searchTable searchtextarea" />
                            </div>
                        </form>
                    </div>
                    <div className="welcome group mn-group">
                            {
                                this.state.UserList != null && this.state.UserList.length > 0 ?
                                    <table>
                                        <thead>
                                            <tr className="header">
                                                <th className="first-one">Group Number</th>
                                                <th className="second-one">Commission</th>
                                                <th className="third-one">Action</th>
                                            </tr>
                                        </thead>
                                    <tbody id="inactive_reps">
                                        {
                                            this.state.UserList_Temp.map((e1, index) => {
                                                return (
                                                    <tr className="userDashData" key={index}>
                                                        <td className="first-one">
                                                            {e1.groupNumber}
                                                        </td>
                                                        <td className="second-one">                                                            
                                                            {
                                                                e1.isineditedmode ? <input type="text" className="form-control" name="commission" defaultValue={e1.commission} /> : e1.commission 
                                                            }
                                                            
                                                        </td>
                                                        <td className="third-one">
                                                            {
                                                                e1.isineditedmode ?
                                                                <div>
                                                                    <input data-text={e1.groupNumber} onClick={this.saveUpdates} type="button" className="btn" value="Save" />
                                                                    <input data-text={e1.groupNumber} onClick={this.handleCancel.bind(this)} type="button" className="btn cancel" value="Cancel" />
                                                                </div>:
                                                                <div>
                                                                        {
                                                                            this.props.whIsRule =="true" ? null : 
                                                                                <a href="javascript:void('0')" className="custom-tooltip"><img data-text={index} datagroup={e1.groupNumber} onClick={this.editGroup} src={editIcon} className="edit-icon" alt="edit Icon" /><span className="hover-tooltip edit">Edit</span></a>
                                                                        }
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>)
                                            })
                                        }
                                        </tbody> </table> : 
                                    <div>
                                        {
                                            this.state.loader ?
                                                <div className="please-wait"><h3>Please wait...</h3></div> :
                                                <div className="not-available please-wait color-red"><h3>{this.state.Data_Not_Found}</h3></div>
                                        }
                                    </div>

                            }
                            {
                                this.state.UserList != null && this.state.UserList.length > 12 ?

                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={12}
                                    totalItemsCount={this.state.UserList.length}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />: null
                            }
                            {error &&
                                <div className={'alert-error'}>{error}</div>
                            }

                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default ManageGroup;